import Button from '../Button';
import PlusIcon from '@/icons/plus-circle.svg?react';
import PencilIcon from '@/icons/pencil.svg?react';
import { useTranslation } from 'react-i18next';

interface Props {
  value: number | string | undefined;
  onClick: () => void;
  testId: string;
}

export const COANumberBtn = ({ value, onClick, testId }: Props) => {
  const { t } = useTranslation();

  const icon = value ? (
    <PencilIcon className='h-4 w-4 [&>g>path]:fill-dark [&>g>path]:transition-[fill] group-hover:[&>g>path]:fill-green' />
  ) : (
    <PlusIcon className='h-4 w-4 [&>path]:fill-dark [&>path]:transition-[fill] group-hover:[&>path]:fill-green' />
  );

  return (
    <Button
      data-testid={testId}
      className='group flex items-center !font-semibold'
      styling='naked'
      onClick={onClick}
    >
      {icon}
      &nbsp;
      <span>{value || t('Add')}</span>
    </Button>
  );
};
